import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ys-welcome" }
const _hoisted_2 = { class: "ys-welcome-main" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "ys-welcome-sub" }
const _hoisted_5 = {
  key: 0,
  class: "ys-install-card"
}
const _hoisted_6 = { class: "ys-install-kicker" }
const _hoisted_7 = { class: "ys-install-title" }
const _hoisted_8 = {
  key: 0,
  class: "ys-install-steps"
}
const _hoisted_9 = { class: "ys-welcome-actions" }

import { computed, onMounted } from 'vue'
import logoImg from '@/assets/images/brand/caion-logo-clear.png'
import { isFnaFlavor } from '@/config/appFlavor'
import {
  captureInstallSourceFromUrl,
  forceShowInstallSheet,
  isSmsInstallFlow,
  openInstallSheet,
  promptInstall,
  scheduleAutoInstallSheet,
  usePwaInstall,
} from '@/composables/usePwaInstall'


export default /*@__PURE__*/_defineComponent({
  __name: 'EntryPage',
  setup(__props) {

const fnaMode = computed(() => isFnaFlavor())

const {
  isInstalled,
  fromSms,
  isSmsFlow,
  installGuide,
  primaryInstallLabel,
  refreshInstalled,
} = usePwaInstall()

const showInstallCta = computed(() => !isInstalled.value)

const onInstallClick = async () => {
  const result = await promptInstall()
  if (result === 'manual' || result === 'external') openInstallSheet()
}

onMounted(() => {
  captureInstallSourceFromUrl()
  refreshInstalled()
  if (isInstalled.value) return

  if (isSmsInstallFlow()) {
    forceShowInstallSheet()
    return
  }
  scheduleAutoInstallSheet(400)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(logoImg),
        alt: "카이온",
        class: "ys-logo-wordmark ys-logo-wordmark--lg"
      }, null, 8, _hoisted_3),
      _createElementVNode("p", _hoisted_4, _toDisplayString(fnaMode.value ? '회계담당·기관 영수증 관리' : '장기요양 업무 앱'), 1),
      (showInstallCta.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(fromSms) || _unref(isSmsFlow) ? '문자 링크' : '앱 설치'), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(fromSms) || _unref(isSmsFlow) ? '앱을 설치하시겠습니까?' : '앱으로 설치해 주세요'), 1),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "ys-install-desc" }, " Chrome · Safari · 삼성 인터넷 · Edge 등 사용 중인 브라우저에서 홈 화면에 추가할 수 있어요. ", -1)),
            (_unref(installGuide)?.steps?.length)
              ? (_openBlock(), _createElementBlock("ol", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(installGuide).steps.slice(0, 3), (step, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(step), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "ys-btn ys-btn-primary ys-install-btn",
              onClick: onInstallClick
            }, _toDisplayString(_unref(primaryInstallLabel)), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        type: "button",
        class: "ys-btn ys-btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/login')))
      }, " 로그인 "),
      (!fnaMode.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ys-btn ys-btn-ghost",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/signup')))
          }, " 회원가입 "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})